import React from 'react';
import PropTypes from 'prop-types';

import { Table} from 'reactstrap';
import { OrderItem } from './OrderItem';
import { getClassNameOrderStatus } from 'helpers/order_helper';
import { convertToNumber, formatNumber } from 'helpers/formats';

function OrderSummary({ items }) {
    return (
        <>
            <div className="py-2 mt-3">
                <h3 className="font-size-14 fw-bold">Resumen de pedido</h3>
            </div>
            <div className="table-responsive">
                <Table className="table-nowrap table-bordered table-condensed">
                    <thead>
                        <tr className='table-light'>
                            <th style={{ width: "70px" }}>No.</th>
                            <th>Producto</th>
                            <th className="text-center">Peso Prom.</th>
                            <th className="text-end">Cantidad</th>
                            <th className="text-end">Precio unitario</th>
                            <th className="text-end">Totales</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            items.map(({ id, product, weight, weight_max, quantity, unit_price, total }) => (
                                <OrderItem 
                                    key={ id }
                                    id={ id }
                                    peso={ (Number(weight) + Number(weight_max)) / 2 }
                                    product={ product }
                                    quantity={ quantity }
                                    unit_price={ unit_price }
                                    total={ total }
                                />
                            ))
                        }
                    </tbody>
                    <thead>
                        <tr className='table-light'>
                            <th colSpan={5} className="text-end">Total</th>
                            <th className="text-end">
                            { 
                                formatNumber(
                                    items.reduce( (previus, e) => { return previus + convertToNumber(e.total); }, 0)
                                )
                            }
                            </th>
                        </tr>
                    </thead>
                </Table>
            </div>
        </>
    )
}

OrderSummary.propTypes = {
    items: PropTypes.any
};

export default OrderSummary;
